import { simpleActionCreator } from '../../core/utils/store.util';
import { WorkflowUiConfig } from '../interfaces/workflow-ui-config.interface';
import { IWorkflowRequest } from '../interfaces/workflow-request.interface';
import { IResourcesMap } from '../interfaces/resource-map.interface';
import { Action } from '@ngrx/store';

export enum WorkflowConfigActions {
  StartFetching = 'WorkflowConfigActions.StartFetching',
  Set = 'WorkflowConfigActions.Set',
  SetActiveWorkflow = 'WorkflowConfigActions.SetActiveWorkflow',
  SetResourceMap = 'WorkflowConfigActions.SetResourceMap',
  Init = 'WorkflowConfigActions.Init'
}

export class InitCurrentActiveWorkflowState implements Action{
  readonly type = CurrentActiveWorkflowState.INIT;

  constructor(){}
}

export class InitGetResourcesMapState implements Action{
  readonly type = GetResourcesMapState.INIT;

  constructor(){}
}

export enum GetResourcesMapState{
  INIT = 'Init Get Resource Map State'
}

export enum CurrentActiveWorkflowState{
  INIT = 'Init Current Active Workflow State'
}

export interface StartFetchingPayload {
  workflowId: string;
  revisionId: string;
}

export const startFetchingWorkflowUiConfig = simpleActionCreator<StartFetchingPayload>(WorkflowConfigActions.StartFetching);
export const setWorkflowUiConfig = simpleActionCreator<WorkflowUiConfig>(WorkflowConfigActions.Set);
export const setActiveWorkflow = simpleActionCreator<IWorkflowRequest>(WorkflowConfigActions.SetActiveWorkflow);
export const setResourceMap = simpleActionCreator<IResourcesMap>(WorkflowConfigActions.SetResourceMap);
export const initWorkflow = simpleActionCreator<{ }>(WorkflowConfigActions.Init)({ });
